import React from 'react';
import { Typography, Breadcrumbs, Box } from '@material-ui/core';

/*styles */
import useStyles from '../../styles';

/*components */
import OutgoingTable from './Components/OutgoingTable';

export default function Outgoing(props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.pageContainer}>
        <Box>
          <Typography
            variant="h2"
            className={classes.textBold}
            align="left"
            gutterBottom={true}
          >
            Outgoing
          </Typography>
          <Breadcrumbs aria-label="breadcrumb">
            <span color="inherit">Position</span>
            <span color="inherit">ACATS</span>
            <Typography color="primary">Outgoing</Typography>
          </Breadcrumbs>
        </Box>
        <Box mt={2}>
          <OutgoingTable params={props} />
        </Box>
      </div>
    </React.Fragment>
  );
}
